import { render, staticRenderFns } from "./MoleculeContentSliderBrochure.vue?vue&type=template&id=6d7b0cb3&"
import script from "./MoleculeContentSliderBrochure.vue?vue&type=script&lang=js&"
export * from "./MoleculeContentSliderBrochure.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports